export const PASSWORD_MIN_LENGTH = 15
export const PASSWORD_MAX_LENGTH = 64
export const PASSWORD_CONFIRMATION_MISMATCH_MESSAGE = 'You have entered 2 different passwords'

const SEQUENCES = [
  '1234', '2345', '3456', '4567', '5678', '6789', '7890', '0123',
  'abcd', 'bcde', 'cdef', 'defg', 'efgh', 'fghi', 'ghij', 'hijk',
  'ijkl', 'jklm', 'klmn', 'lmno', 'mnop', 'nopq', 'opqr', 'pqrs',
  'qrst', 'rstu', 'stuv', 'tuvw', 'uvwx', 'vwxy', 'wxyz',
  'qwer', 'asdf', 'zxcv',
]

const toLowerString = (value) => String(value ?? '').trim().toLowerCase()

const emailPrefix = (email) => {
  const prefix = toLowerString(email).split('@')[0] ?? ''

  return prefix.length > 3 ? prefix : ''
}

export function evaluatePassword(password, context = {}) {
  const value = String(password ?? '')
  const characterLength = Array.from(value).length
  const lowerValue = value.toLowerCase()
  const personalValues = [
    emailPrefix(context.email),
  ].filter(Boolean)

  return {
    hasMinMaxLength: characterLength >= PASSWORD_MIN_LENGTH && characterLength <= PASSWORD_MAX_LENGTH,
    hasNoSequentialCharacters: !SEQUENCES.some((sequence) => lowerValue.includes(sequence) || lowerValue.includes(sequence.split('').reverse().join(''))),
    hasNoRepeatedCharacters: !/(.)\1{3,}/u.test(lowerValue),
    hasNoPersonalData: !personalValues.some((item) => lowerValue.includes(item)),
  }
}

export function isPasswordValid(password, context = {}) {
  return Object.values(evaluatePassword(password, context)).every(Boolean)
}
